import { API_BASE_URL } from '@/constants';
import HttpClient from '@/api/HttpClient';

export default {
  getStores() {
    return HttpClient.get({ url: `${API_BASE_URL}/public/store/search` });
  },
  getBundles() {
    return HttpClient.post({ url: `${API_BASE_URL}/public/bundle/search` });
  },
  askQuestion(data) {
    return HttpClient.post({
      url: `${API_BASE_URL}/public/app/customer-question`,
      data: data,
    });
  },
  submitLoanApplication(loanApplicationData) {
    return HttpClient.post({
      url: `${API_BASE_URL}/public/subscription`,
      data: loanApplicationData,
    });
  },
  submitPayment(referenceNumber, language) {
    return HttpClient.post({
      url: `${API_BASE_URL}/public/subscription/${referenceNumber}/resurs-merchant/v2/payment`,
      headers: {
        'Fairown-Language-Code': language,
      },
    });
  },
  pollPaymentResponse(referenceNumber) {
    return HttpClient.get({
      url: `${API_BASE_URL}/public/subscription/${referenceNumber}/payment/status`,
    });
  },
  linkSubscription(linkedSubscription) {
    return HttpClient.post({
      url: `${API_BASE_URL}/public/renewal/link-subscriptions`,
      data: linkedSubscription,
    });
  },
  getRenewableProducts(subscriptionReferenceNumber) {
    return HttpClient.get({
      url: `${API_BASE_URL}/public/customer/search/${subscriptionReferenceNumber}/renewable-products`,
    });
  },
};
